export default "__VITE_ASSET__vQA069Uj__"